import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";

import CountBadge from "@ats/src/components/shared/CountBadge";
import Icon from "@ats/src/components/shared/Icon";
import Tooltip from "@ats/src/components/shared/Tooltip";

export interface JobApplicationFiltersButtonProps {
  appliedFilterCount: number;
  onClick: () => void;
}

const JobApplicationFiltersButton: React.FunctionComponent<JobApplicationFiltersButtonProps> = ({
  appliedFilterCount,
  onClick,
}) => {
  return (
    <Styled.Container>
      <Tooltip label="Filters">
        <Styled.Button type="button" onClick={onClick}>
          <Icon name="filter" />
        </Styled.Button>
      </Tooltip>
      <Styled.Badge>
        <CountBadge count={appliedFilterCount} />
      </Styled.Badge>
    </Styled.Container>
  );
};

export default JobApplicationFiltersButton;

/* Styled Components
======================================================= */
let Styled: any;
Styled = {};

Styled.Container = styled.div`
  label: JobApplicationFiltersButton;
  position: relative;
`;

Styled.Button = styled.button((props: any) => {
  const t: any = props.theme;
  return css`
    label: JobApplicationFiltersButton_Button;
    ${[t.w(8), t.h(8), t.p(1), t.rounded.sm, t.text.sm]};
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s ease;
    border: none;
    background: none;
    color: ${t.dark ? t.color.gray[400] : t.color.gray[600]};
    cursor: pointer;

    &:hover {
      color: ${t.dark ? t.color.gray[200] : t.color.black};
      background-color: ${t.dark ? t.color.gray[700] : t.color.gray[100]};
    }
  `;
});

Styled.Badge = styled.span`
  label: JobApplicationFiltersButton_Badge;
  position: absolute;
  top: -3px;
  right: -3px;
  pointer-events: none;
  z-index: 1;
`;
